import React from 'react';
import Label from 'components/_utility/Label';

const steps = [
  {
    label: <Label name="financeOptionsLabel"></Label>,
    labelKey: 'financeOptionsLabel',
    number: 1,
  },
  {
    label: <Label name="customerDetailsNavigationHeading"></Label>,
    labelKey: 'customerDetailsNavigationHeading',
    number: 2,
  },
  {
    label: <Label name="yourDealerLabel"></Label>,
    labelKey: 'yourDealerLabel',
    number: 3,
  },
  {
    label: <Label name="confirmationLabel"></Label>,
    labelKey: 'confirmationLabel',
    number: 4,
  }
];

export default steps;
